
/**
 * A convenience implementation of val() for agFields.
 */
(function ($) {

    var originalVal = $.fn.val;

    $.fn.val = function (value) {

        if (this.hasClass('ag-field')) {
            // special handling of agField
            if (arguments.length >= 1)
                return this.agField('value', value);

            return this.agField('value');

        } else {
            // default implementation
            if (arguments.length >= 1)
                return originalVal.call(this, value);

            return originalVal.call(this);
        }
    };

    // because of conflicts between bootstrap and jquery ui widgets
    $.widget.bridge('uibutton', $.ui.button);
    $.widget.bridge('uitooltip', $.ui.tooltip);

})(jQuery);